class ComponentProductFormSubscription extends HTMLElement {
  constructor() {
    super();

    this.elements = {
      select: this.querySelector("select"),
      input: this.querySelector("input")
    }
  }

  connectedCallback() {
    this.elements.select.addEventListener("change", (event) => {
      this.elements.input.value = this.elements.select.value;
      this.elements.input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }
}

customElements.define("component-product-form-subscription", ComponentProductFormSubscription);
